export default "__VITE_ASSET__DWq2YeLJ__"